import React, { Component, createRef } from 'react';
import Validator from 'validatorjs';
import qs from 'query-string';
import ReCAPTCHA from 'react-google-recaptcha';
import { Redirect, Link } from 'react-router-dom';
import { Form, Row, Col, Image } from 'react-bootstrap';

import ByPactopia from './ByPactopia';
import { Auth, Http } from '../../support';
import Storage from '../../support/Storage';
import { FormControl } from '../../facturotopia';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';

class SignIn extends Component {

  state = {}

  recaptchaRef = null;

  constructor(props) {
    super(props);

    this.state = {
      tenancy: qs.parse(props.location.search)?.tenancy,
      data: {},
      loaded: false,
      busy: false,
      restored: false,
      isLoggedIn: false,
      validator: new Validator({}, this.rules)
    };

    this.recaptchaRef = createRef();
  }

  async componentDidMount() {
    let isLoggedIn = Auth.isAuthenticated();

    if (!Auth.isAuthenticated() && !!Auth.getUser()) {
      const data = await Storage.get('facturotopia');

      if (!!data) {
        Auth.setData(data);

        isLoggedIn = true;
      }
    } else {
      await Auth.logout();
    }

    if (isLoggedIn) {
      this.setState({
        isLoggedIn
      });
    } else {
      setTimeout(() => {
        this.setState({
          loaded: true
        });
      });
    }
  }

  get rules() {
    return {
      email: ['required', 'email'],
      password: ['required', 'string', 'min:8'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValidForm: validator.passes()
    });
  }

  handleOnSubmit = async () => {
    this.setState({
      busy: true
    });

    try {
      const token = await this.recaptchaRef.current.executeAsync();

      const params = {
        email: this.state.data.email,
        password: this.state.data.password,
        challenge: token
      }

      const response = await Http.post('/auth/tokens', params);

      const { access_token, ...rest } = response;

      const user = {
        ...rest,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const { empresa, emisor, cliente } = rest;

      const data = {
        token: { access_token },
        user,
        empresa,
        emisor: emisor || {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setState({
        isAccountSuspended: response.cliente.status === -1 || response.cliente.status === -2,
        isLoggedIn: true,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  handleOnAction = () => {
    this.setState({
      error: undefined
    })
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value
      }
    });
  }

  render() {
    const {
      data,
      validator,
      isValidForm,
      isLoggedIn,
      isAccountSuspended,
      busy,
      loaded,
      error,
      tenancy
    } = this.state;

    // const { onForgotPasswordClick } = this.props;

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/app/dashboard' } };

      if (from.pathname === '/auth/login') {
        from.pathname = '/app/dashboard';
      }

      if(isAccountSuspended) {
        return <Redirect to="/suspended" state={ from } />;
      }

      return <Redirect to="/bridge" state={ from } />;
    }

    if (!loaded) {
      return <Loading />
    }

    return (
      <>
        <Form autoComplete="off">

          <div className="auth-content">
            <div className="avatar mt-4">
              <div className="auth-logo">
                <div className="d-flex justify-content-start">
                    <Image src="/img/logo.png"
                      className="auth-logo-img opacity-6"
                      fluid={ true }
                    />
                    <p className="title text-muted">Facturotöpia</p>
                </div>
              </div>
            </div>

            <div className="login-content">
              <div className="pb-3">
                <h6 className="text-muted">
                  Inicia sesión para continuar
                </h6>
              </div>

              <div id="output"></div>

              <FormControl type="email"
                label="Email"
                name="email"
                placeholder="tu-email@facturotopia.com"
                help=""
                autoFocus={ true }
                validator={ validator }
                value={ data.email }
                onChange={ this.handleOnChange }
              />

              <FormControl type="password"
                label="Contraseña"
                name="password"
                placeholder="*********"
                help=""
                validator={ validator }
                value={ data.password }
                onChange={ this.handleOnChange }
              />

              <ReCAPTCHA
                size="invisible"
                ref={ this.recaptchaRef }
                sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
                onChange={ this.onCaptchaChange }
              />

              <Row>
                <Col className="text-right">
                  <LoadingButton type="button"
                    block={ true }
                    loading={ busy }
                    disabled={ !isValidForm || busy }
                    onClick={ this.handleOnSubmit }
                  >
                    { busy && 'Iniciando sesión...'}
                    { !busy && 'Iniciar sesión' }
                  </LoadingButton>
                </Col>
              </Row>

              { !!error && (
                <div className="py-3">
                  { this.renderError() }
                </div>
              )}
            </div>

            <Row>
              <Col className="text-center mt-3">
                ¿No eres cliente? <Link to={`/auth/registro?w=1${tenancy ? '&tenancy=' + tenancy : ''}`}> Crea tu cuenta</Link>
              </Col>
            </Row>

            <Row>
              <Col className="text-center mt-1">
                <Link to={`/auth/password/email${tenancy ? '?tenancy=' + tenancy : ''}`}>
                  ¿Olvidaste tu contraseña?
                </Link>
              </Col>
            </Row>

            <Row className="my-3">
              <Col>
                <small className="text-muted">
                  Al continuar aceptas nuestros <a href="/">Términos del servicio</a> y nuestro <a href="/">Acuerdo de privacidad</a>
                </small>
              </Col>
            </Row>

            <ByPactopia />

          </div>
        </Form>
      </>

      )
    }
  }

  export default SignIn;